import React from 'react'
import "./css/common.css"

export default function DataCleaningTab(props) {
        return (
                <div className="main_tab scrollbar_property">
                        DATACLEANING
                        <br></br>
                        {props.selected_dataset}
                </div>
        )
}
